import { render, staticRenderFns } from "./GroupMealsCompaniesChart.vue?vue&type=template&id=b4e8074e"
import script from "./GroupMealsCompaniesChart.vue?vue&type=script&lang=js"
export * from "./GroupMealsCompaniesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports